import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var hasYm = function hasYm() {
  return !!window.ym;
};
var COUNTER_ID = 26001372;
export var ymPushEvent = function ymPushEvent() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'params';
  if (hasYm()) {
    var _window$ym, _window;
    (_window$ym = (_window = window).ym) === null || _window$ym === void 0 ? void 0 : _window$ym.call(_window, COUNTER_ID, key, payload);
  }
};
export var handleYmAnalytics = function handleYmAnalytics(params) {
  ymPushEvent(_objectSpread({}, params));
};
export var handlePersonalYmAnalytics = function handlePersonalYmAnalytics(params) {
  ymPushEvent({
    personal_account: params
  });
};
export var pushPersonalAccountAnalytics = function pushPersonalAccountAnalytics(params) {
  handlePersonalYmAnalytics({
    fub_profile: _objectSpread({
      page_url: "".concat(window.location.origin).concat(window.location.pathname),
      page_path: window.location.pathname,
      page_title: document.title
    }, params)
  });
};
export var pushTopEvAnalytics = function pushTopEvAnalytics(params) {
  handleYmAnalytics({
    top_ev_: _objectSpread({
      page_url: "".concat(window.location.origin).concat(window.location.pathname),
      page_path: window.location.pathname,
      page_title: document.title
    }, params)
  });
};